"use client";
import optimoveQueue, {
  LOAD_TIMEOUT_MS,
} from "@workspace/casino_pages/legacyLayer/client/optimove/queue";
import Script from "next/script";
import { type FC, useCallback, useEffect } from "react";

const OPTIMOVE_SDK_URL = "https://sdk.optimove.net/v2/websdk/";

type Props = {
  tenantId: number;
  tenantToken: string;
  optimoveUserId?: string;
};

const OptimoveClient: FC<Props> = ({
  tenantId,
  tenantToken,
  optimoveUserId,
}) => {
  const handleLoad = useCallback(() => {
    const api = window.optimoveSDK?.API;
    if (!api) {
      optimoveQueue.fail("script loaded without exposing window.optimoveSDK");
      return;
    }
    optimoveQueue.ready(api, optimoveUserId);
  }, [optimoveUserId]);

  const handleError = useCallback(() => {
    optimoveQueue.fail("script failed to load");
  }, []);

  useEffect(() => {
    const timer = setTimeout(
      () => optimoveQueue.giveUpIfStillLoading(),
      LOAD_TIMEOUT_MS,
    );
    return () => clearTimeout(timer);
  }, []);

  const src = `${OPTIMOVE_SDK_URL}?tenant_id=${tenantId}&tenant_token=${encodeURIComponent(tenantToken)}`;

  return (
    <Script
      id="optimove-sdk"
      strategy="lazyOnload"
      src={src}
      onLoad={handleLoad}
      onError={handleError}
    />
  );
};

export default OptimoveClient;
